import { Box, Container, Grid, TextareaAutosize, Typography, Button  } from '@mui/material'
import React, { useEffect } from 'react' 
import Stack from '@mui/material/Stack';
import preview from "../../images/sidebg.jpg";
import TextField from '@mui/material/TextField';
import { Label } from 'semantic-ui-react';
import { useState } from 'react';
import { useWeb3React } from '@web3-react/core';
import axios from 'axios';
import { API_URL } from '../../Config';
import swal from 'sweetalert';
import { useHistory } from "react-router-dom";

const Createcollection = () => {
    const { account } = useWeb3React();
    const [image, setimage] = useState("");
    const [Preview, setpreviewimage] = useState("");
    const redirect = useHistory();

    const CreateCollection = async (event) => {
        event.preventDefault();
        let collectioname = event.target.collname.value;
        let collectionsymbol = event.target.colsymb.value;
        let description = event.target.coldescription.value;
        let image = event.target.image.files;
        if (collectioname != "" && collectionsymbol != "" && description != "" && image != "") {

            let filename;
            if (image.length > 0) {
                filename = image[0].name;
                filename = filename.replace(/^.*[\\\/]/, '')
            }
            var data = new FormData();
            data.append("name", collectioname);
            data.append("symbol", collectionsymbol);
            data.append("address", account);
            data.append("image", image[0]);
            data.append("description", description);
            data.append("action", "createCollection");

            return await axios.post(`${API_URL}/createCollection.php`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then((response) => {

                if (response.data.code == 200) {
                    swal({
                        title: "Success",
                        text: response.data.message,
                        icon: "success",
                        allowOutsideClick: false,
                        confirmButtonText: 'ok',
                        confirmButtonColor: '#2dbe60',
                    }).then(() => {
                        redirect.push('/single-nft');
                    })
                }
            });

        } else {
            swal({
                title: "Warning",
                text: "Please fill all the details",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: 'ok',
                confirmButtonColor: '#2dbe60',
            })
        }
    }

    const getimage = (e) => {
        if (e.target.files && e.target.files.length > 0) setimage(e.target.files[0]);
    }

    useEffect(() => {
        if (image?.length < 1) return;
        const previewimage = URL.createObjectURL(image);
        setpreviewimage(previewimage);
    }, [image])

    return (
        <>
            <Box className='createcollection_bg'>
                <Typography variant='h2' fontWeight='600' fontSize='45px'>
                    Create Collections
                </Typography>
            </Box>
            <Box>
                <Container maxWidth='xl'>
                    <form onSubmit={CreateCollection}>
                        <Grid container spacing={2}>
                            <Grid item lg={8} sm={12} md={8} xs={12}>
                                <Box className='create_items'>
                                    <Typography variant='h4' fontSize='22px' fontWeight='500' paddingBottom='10px'>Create New Item</Typography>
                                    <hr style={{ border: '1px solid #e9e9e9' }}></hr>
                                    <Typography variant='h5' fontWeight='500' fontSize='17px' paddingBottom='5px' paddingTop='10px'>Upload File</Typography>
                                    <Box className='recognize'>
                                        <Typography variant='h6' fontWeight='400' fontSize='16px' paddingBottom='20px'>JPG, PNG, GIF, WEBP, Max 100mb.</Typography>
                                        <Stack direction="row" spacing={2}>
                                            <Button variant="contained" component="label">
                                                Choose File
                                                <input hidden accept="image/*" name="image" multiple type="file" onChange={getimage} />
                                            </Button>
                                        </Stack>
                                    </Box>

                                    <Box sx={{marginTop:'1.3rem'}} className='coll_det'>
                                        <Label>Collection Name</Label>
                                        <TextField id="outlined-basic" fullWidth variant="outlined" name='collname' />
                                        <Label>Collection symbol</Label>
                                        <TextField id="outlined-basic" fullWidth variant="outlined" name='colsymb' />
                                        <Label>Description</Label>
                                        <TextareaAutosize placeholder=" " name="coldescription" />            
                                        <Box sx={{marginY:'1.3rem'}}> 
                                            <Button type="submit" variant="contained"> Submit</Button>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item lg={4} sm={12} md={4} xs={12}>
                                <Box className='create_items'>
                                    <Typography variant='h4' fontSize='22px' fontWeight='500' paddingBottom='10px'>Preview Item</Typography>
                                    <hr style={{ border: '1px solid #e9e9e9' }}></hr>
                                    <Box className='preview_box' marginY='30px' style={{ border: '1px solid #e9e9e9', borderRadius: '15px' }} padding='10px'>
                                        <img src={Preview ? Preview : preview} width='100%' style={{ borderRadius: '15px' }} />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </Container>
            </Box>
        </>
    )
}

export default Createcollection